import React, { memo, useCallback, useContext, MouseEvent } from 'react'
import tw from 'twin.macro'
import { Onboarding } from 'src/interfaces/onboarding'
import { Button } from 'src/components/shared/Button'
import { HorizontalDotsMinor } from '@shopify/polaris-icons'
import { OnboardingsTableContext } from '../../onboardings-table/OnboardingsTable.context'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission } from 'src/constants/user'

interface Props {
  onboarding: Onboarding
}

const OnboardingsItemActionButtonComponent = ({ onboarding }: Props) => {
  const { openOnboardingsItemAction } = useContext(OnboardingsTableContext)

  const { hasPermission } = useCheckPermissions()

  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      openOnboardingsItemAction(event, onboarding)
    },
    [onboarding],
  )

  if (!hasPermission(UserPermission.PartnerDriversEdit)) {
    return null
  }

  return (
    <Button
      data-testid={`contractors-onboarding-list-row-${onboarding.id}-actions-btn`}
      className={tw`px-2 rounded h-[28px]`}
      color="grey"
      size="small"
      leftIcon={<HorizontalDotsMinor width={20} height={20} />}
      onClick={handleClick}
    />
  )
}

export const OnboardingsItemActionButton = memo(OnboardingsItemActionButtonComponent)
